import { useState } from "react";
import {
  capToBalance,
  draftToNumber,
  groupAmount,
  sanitizeAmount,
} from "../utils/format";
import { applyWagerChip } from "../utils/wagerChip";

/**
 * Local wager draft + chip handlers. Parent owns committed wager via onWagerChange.
 *
 * @param {object} params
 * @param {number} params.wager
 * @param {(value: number) => void} params.onWagerChange
 * @param {number} params.availableBalance
 */
const formatWithDecimals = (value) => Number(value).toFixed(2);

export const useWagerInput = ({ wager, onWagerChange, availableBalance }) => {
  const [wagerDraft, setWagerDraft] = useState(formatWithDecimals(wager));

  const commitDraft = (draft) => {
    setWagerDraft(draft);
    onWagerChange(draftToNumber(draft));
  };

  const onWagerInput = (event) => {
    commitDraft(sanitizeAmount(event.target.value));
  };

  // An emptied field stays empty (the placeholder shows); a lone "." is cleared
  const onWagerBlur = () => {
    if (wagerDraft === ".") setWagerDraft("");
  };

  const setWager = (value) => {
    setWagerDraft(String(value));
    onWagerChange(value);
  };

  return {
    wagerDraft,
    displayWager: groupAmount(wagerDraft),
    onWagerInput,
    onWagerBlur,
    setWager,
    onHalf: () => setWager(applyWagerChip(wager, 0.5, availableBalance)),
    onDouble: () => setWager(applyWagerChip(wager, 2, availableBalance)),
    onMax: () => setWager(capToBalance(availableBalance, availableBalance)),
  };
};
